$(document).ready(function() {

  /* begin: nav button clicked */
  var clicked = false;

  $("nav .mobile").click(function(e) {
    e.preventDefault();
    if (!clicked){
      TweenMax.to($("#nav"), 0, {"opacity":"0", "display":"none", "y":"30px"});

      /* X transition */
      TweenMax.killTweensOf(this);
      TweenMax.to($(this).find(".line1"), 0.25, {"rotation":"45deg", "transformOrigin":"top left", "y":"-1", "x":"3", ease:Quad.easeInOut});
      TweenMax.to($(this).find(".line2"), 0.25, {"opacity":"0", ease:Quad.easeInOut});
      TweenMax.to($(this).find(".line3"), 0.25, {"rotation":"-45deg", "transformOrigin":"bottom left", "y":"1", "x":"3", ease:Quad.easeInOut});

      TweenMax.to($(this).find(".prc-mobile-icons .site-header__cart"), 0.25, {"opacity":"0", ease:Quad.easeInOut});

      /* Add active state */
      $(this).addClass("active");
      $('body').addClass('nav-active');

      /* Nav overlay menu */
      TweenMax.to($("#overlay"), 0.30, {"opacity":"1", "display":"block", ease:Quad.easeInOut});
      TweenMax.to($("#nav"), 0.30, {"delay":"0.3", "opacity":"1", "display":"block", "y":"0", ease:Quad.easeInOut});
      TweenMax.to($(".prc-nav-icons"), 0.30, {"delay":"0.3", "opacity":"1", "display":"block", "y":"0", ease:Quad.easeInOut});
      // TweenMax.set($("#logo"), {css:{backgroundImage:'url(https://cdn.shopify.com/s/files/1/0027/5677/1887/files/logo-white_838d7fbd-c9bc-48a2-97ae-4042879498bd.svg?8603479618481250687)'}});
      // TweenMax.set($(".site-header__cart"), {css:{backgroundImage:'url(https://cdn.shopify.com/s/files/1/0027/5677/1887/files/cart-white_fb1ccbda-710f-4f80-bb63-470a6fdd2448.svg?5093742142871892242)'}});
	  // TweenMax.set($("nav ul li a span"), {css:{backgroundImage:'url(https://cdn.shopify.com/s/files/1/0027/5677/1887/files/dropdown.svg?14478333059254341438)'}});
      TweenMax.set($(".site-header__cart-count span"), {css:{color:'#fff'}});      
      clicked = true;

    } else {

      /* hamburger transition back to default */
      TweenMax.killTweensOf(this);
      TweenMax.to($(this).find(".line1"), 0.25, {"rotation":"0", "transformOrigin":"top left", "y":"0", "x":"0", ease:Quad.easeInOut});
      TweenMax.to($(this).find(".line2"), 0.25, {"opacity":"1", ease:Quad.easeInOut});
      TweenMax.to($(this).find(".line3"), 0.25, {"rotation":"0", "transformOrigin":"bottom left", "y":"0", "x":"0", ease:Quad.easeInOut});

      TweenMax.to($(this).find(".prc-mobile-icons .site-header__cart"), 0.25, {"opacity":"1", ease:Quad.easeInOut});

      /* Remove active state */
      $(this).removeClass("active");
      $('body').removeClass('nav-active');

      /* Nav overlay menu close */
      TweenMax.to($("#nav"), 0.30, {"opacity":"0", "display":"none", "y":"30px", ease:Quad.easeInOut});
      TweenMax.to($("#overlay"), 0.30, {"opacity":"0", "display":"none", ease:Quad.easeInOut});
      TweenMax.to($(".prc-nav-icons"), 0.30, {"opacity":"0", "display":"none", "y":"30px", ease:Quad.easeInOut});
      // TweenMax.to($(".prc-nav-icons"), 0.30, {"delay":"0.3", "opacity":"1", "display":"block", "y":"0", ease:Quad.easeInOut});
      // TweenMax.set($("#logo"), {css:{backgroundImage:'url(https://cdn.shopify.com/s/files/1/0027/5677/1887/files/logo.svg?3537056639115272889)'}});
      // TweenMax.set($(".site-header__cart"), {css:{backgroundImage:'url(https://cdn.shopify.com/s/files/1/0027/5677/1887/files/cart.svg?6611762682866054358)'}});
	  // TweenMax.set($("nav ul li a span"), {css:{backgroundImage:'url(https://cdn.shopify.com/s/files/1/0027/5677/1887/files/dropdown_grey.svg?11250068287570386747)'}});

      TweenMax.set($(".site-header__cart-count span"), {css:{color:'#8e8f8f'}});
      
      clicked = false;
    }
  });
  /* end: nav button clicked */

  $(".close").click(function() {
    TweenMax.to($(".alert-success"), 0.30, {"display":"none", ease:Quad.easeInOut});
  });
  
  $("#dropdown").click(function() {
    $('.dropdown').slideToggle(300);
  });

  $('.prc-dropdown-activate').click(function(e){
    e.preventDefault();
    $(this).parents('.menu-link--level-2').toggleClass('active');
  });



});